<template>
  <v-main>
    <heads/>
    <v-container id="Home" class="bg_img" fluid  >
      <v-row class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <v-row align="end" justify="center" style="height: 50vh; min-height: 300px" >
            <v-avatar class="img_perfil upper_layer" :size=" ViewMobile ? 170 : 200" >
              <img src="../assets/img/foto.png" alt="Fábio Cardoso">
            </v-avatar>
          </v-row>
          <v-row align="start" justify="center">
            <div :class="ViewTablet ? 'text-h4 mt-4 white--text upper_layer' : ViewMobile ? 'text-h5 mt-4 white--text upper_layer' : ' text-md-h3 text-lg-h2 mt-4 white--text upper_layer'">{{textName}}</div>
          </v-row>
          <v-row align="start" justify="center" style="height: 100px;">
            <div :class="ViewTablet ? ' text-h6 mt-4 white--text upper_layer' : ViewMobile ? 'text-caption mt-4 white--text upper_layer' :  'text-md-h4 text-lg-h4 mt-4 white--text upper_layer'">
              <vue-typer 
                :text='textShow'
                :repeat='Infinity'
                :shuffle='false'
                initial-action='typing'
                :pre-type-delay='70'
                :type-delay='70'
                :pre-erase-delay='1000'
                :erase-delay='250'
                erase-style='clear'
                :erase-on-complete='true'
                caret-animation='expand'
              ></vue-typer>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container id="About" class="mt-6">
      <v-row>
        <v-col :class="ViewMobile ? 'col-12' : 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6'">
            <div :class="ViewMobile ? 'mt-4 text-h5 upper_layer font-weight-black' : 'mt-4 text-h3 upper_layer font-weight-black'">{{textApren}}</div>
            <div class="mt-2 text_dev">{{textDev}} </div>
            <div class="mt-1 pr-2 text-justify">{{textAllApren}} </div>
        </v-col>
        <v-col cols="12"  class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-2 pl-2 mt-lg-0 mt-xl-12">
          <div :class="ViewMobile ? 'mt-4 text-h6 upper_layer font-weight-bold' : 'mt-4 text-h5 upper_layer font-weight-bold'">Other information</div>
          <ul class="text-body-1 mt-2">
            <li>Date of Birth: <span>22/02/1998</span></li>
            <li>Nationality: <span>Portuguese</span></li>
            <li>Driving licence: <span>B, B1</span></li>
            <li>Language: <span class="text-hover" @click="DialogLanguage = true">English</span></li>
          </ul>
        </v-col>
        <v-col cols="12" class="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-4 pl-2 mt-lg-0 mt-xl-12">
          <div :class="ViewMobile ? 'mt-4 text-h6 upper_layer font-weight-bold' : 'mt-4 text-h5 upper_layer font-weight-bold'">Extracurricular activities</div>
          <ul class="text-body-1 mt-2">
            <li>Student association member: <span>23/10/2019 - Current </span></li>
            <li>Director of the computer engineering student nucleus: <span>09/09/2019 - Current </span></li>
          </ul>
        </v-col>
      </v-row> 
    </v-container>
    <v-container id="EXPERIENCE" class="mt-6">
      <div :class=" ViewMobile ? 'text-h4 text-center upper_layer' : 'text-h3 text-center upper_layer'">EXPERIENCE</div>
      <v-row>
        <v-col class="col-xs-12 col-sm-12 col-md-6 mt-5">
          <v-timeline>
             <v-timeline-item fill-dot color="#FFC000"  icon="fas fa-suitcase" large>
              <span slot="opposite" :class=" ViewMobile ? 'text-h6 text-justify' : 'text-h4'">Working History</span>
            </v-timeline-item>
            <v-timeline-item v-for="(historyWork, i) in arrHistoryWork" key="historyWork" fill-dot color="#FFC000" small :right="i % 2 == 0 ? true : false" :left="i % 2 == 0 ? false : true">
              <span slot="opposite" :class=" ViewMobile ? 'text-body-2' : '' ">{{ historyWork.data}}</span>
                <v-card class="elevation-2">
                  <v-card-title :class=" ViewMobile ? 'text-body-1 text-hover text-justify ' : 'headline text-hover text-justify'" @click="dialogHistory(historyWork)">{{ historyWork.company.split(' ')[0]}} <br v-if="ViewMobile"> {{ historyWork.company.split(' ')[1] == null || historyWork.company.split(' ')[1] == '' ? '' : historyWork.company.replace(historyWork.company.split(' ')[0],'').trim()}}</v-card-title>
                  <v-card-text class="text-justify" v-if="!ViewMobile">{{ historyWork.description }}</v-card-text>
                </v-card>
            </v-timeline-item>
             <v-timeline-item fill-dot color="#FFC000" large>
            </v-timeline-item>
          </v-timeline>
        </v-col>
         <v-col class="col-xs-12 col-sm-12 col-md-6 mt-5">
          <v-timeline>
             <v-timeline-item fill-dot color="#FFC000"  icon="fas fa-graduation-cap" large>
              <span slot="opposite":class=" ViewMobile ? 'text-h6 text-justify' : 'text-h4'">School History</span>
            </v-timeline-item>
            <v-timeline-item v-for="(historySchool, i) in arrHistorySchool" key="historySchool" fill-dot color="#FFC000" small :right="i % 2 == 0 ? true : false" :left="i % 2 == 0 ? false : true">
              <span slot="opposite" :class=" ViewMobile ? 'text-body-2' : '' ">{{ historySchool.data}}</span>
                <v-card class="elevation-2">
                  <v-card-title :class=" ViewMobile ? 'text-body-1 text-hover text-justify ' : 'headline text-hover text-justify'" @click="dialogHistory(historySchool)">{{ historySchool.company.split(' ')[0]}} <br v-if="ViewMobile"> {{ historySchool.company.split(' ')[1] == null || historySchool.company.split(' ')[1] == '' ? '' : historySchool.company.replace(historySchool.company.split(' ')[0],'').trim()}}</v-card-title>
                  <v-card-text class="text-justify" v-if="!ViewMobile">{{ historySchool.description }}</v-card-text>
                </v-card>
            </v-timeline-item>
            <v-timeline-item fill-dot color="#FFC000"  large>
            </v-timeline-item>
          </v-timeline>
        </v-col>
      </v-row> 
    </v-container>
    <v-container id="Skills" class="mt-6">
      <div :class="ViewMobile ? 'text-h4 text-center upper_layer' : 'text-h3 text-center upper_layer'">SKILLS</div>
      <v-row>
        <v-col v-for="skill in arrSkills" key="skill" cols="12" class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-5">
          <v-row>
            <div class="text-h7 font-weight-bold ml-4">{{skill.skill}}</div>
            <v-spacer></v-spacer>
            <div class="text-h7 font-weight-bold mr-4"> {{skill.value}} %</div>
          </v-row>
          <v-progress-linear background-color="grey lighten-1" color="#FFC000" rounded :value="skill.value" height="6px"></v-progress-linear>
        </v-col>
      </v-row> 
    </v-container>
    <!-- <v-container id="Portfolio" class="mt-6">
      <div :class="ViewMobile ? 'text-h4 text-center upper_layer' : 'text-h3 text-center upper_layer'">PORTFOLIO</div>
      <v-item-group>
        <v-row>
          <v-col v-for="n in 4" :key="n" cols="12" class="col-sm-6 col-md-6 col-lg-4 col-xl-3" >
            <v-item v-slot:default="{ active, toggle }">
              <v-hover  v-slot:default="{ hover }" open-delay="100" >
                <v-card :elevation="hover ? 6 : 2" class="mt-10 mx-auto " min-width="300" max-width="350" >
                  <v-img height="200px" src="https://cdn.vuetifyjs.com/images/cards/docks.jpg" >  </v-img>
                  <v-btn  class="ma-2 " dark color="#FFC000">Top 10 Australian beaches</v-btn>
                </v-card>
              </v-hover>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
    </v-container>-->
    <v-container id="Contact" class="mt-6">
      <div :class="ViewMobile ? 'text-h4 text-center upper_layer' : 'text-h3 text-center upper_layer'">CONTACT</div>
      <v-row>
        <v-col class=" col-xs-12 col-sm-12 col-md-12 col-lg-9 mt-8 mx-auto">
          <v-row class="mx-auto">
            <v-col cols="12" class="col-xs-12 col-sm-6 col-md-3">
              <v-row>
                <v-avatar color="#FFC000" size="60">
                  <v-icon color="white" medium>fab fa-linkedin</v-icon>
                </v-avatar>
                <v-col class="mt-n2">
                <div class="text-Caption font-weight-bold">Linkedin</div>
                <div> <a href="https://www.linkedin.com/in/fabioamcardoso/" target="blank" style="color: #757575"> Click here </a></div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="col-xs-12 col-sm-6 col-md-3">
              <v-row>
                <v-avatar color="#FFC000" size="60">
                  <v-icon color="white" >fas fa-phone-alt</v-icon>
                </v-avatar>
                <v-col class="mt-n2">
                <div class="text-Caption font-weight-bold">Phone</div>
                <div>+351 936369738</div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="col-xs-12 col-sm-6 col-md-3">
              <v-row>
                <v-avatar color="#FFC000" size="60">
                  <v-icon color="white" >fas fa-envelope </v-icon>
                </v-avatar>
                <v-col class="mt-n2">
                <div class="text-Caption font-weight-bold">E-mail</div>
                <div> <a href="mailto:faavmica@hotmail.com" target="blank" style="color: #757575"> Click here </a></div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="col-xs-12 col-sm-6 col-md-3">
              <v-row>
                <v-avatar color="#FFC000" size="60">
                  <v-icon color="white" >fas fa-map-marker-alt</v-icon>
                </v-avatar>
                <v-col class="mt-n2">
                <div class="text-Caption font-weight-bold">Address</div>
                <div>Ponte de Lima, Viana do Castelo, Portugal</div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <ValidationObserver ref="observer" v-slot="{ validate, reset }">
            <form class="mt-3">
              <ValidationProvider v-slot="{ errors }" name="Name" rules="required|max:20">
                <v-text-field
                  v-model="mail_parms.from_name"
                  :counter="20"
                  :error-messages="errors"
                  label="Name"
                  color="#FFC000"
                  required
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider v-slot="{ errors }" name="email" rules="required|email">
                <v-text-field
                  v-model="mail_parms.from_mail"
                  :error-messages="errors"
                  label="E-mail"
                  color="#FFC000"
                  required
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider  v-slot="{ errors }" name="text" rules="required">
                <v-textarea
                  v-model="mail_parms.message"
                  label="Message"
                  color="#FFC000"
                ></v-textarea>
              </ValidationProvider>     

              <v-btn class="mr-4" :loading="loadingMail" color="#FFC000" @click="sendEmail()" dark rounded>Send Message</v-btn>
            </form>
          </ValidationObserver>
        </v-col>
      </v-row>
      <v-snackbar color="success" top timeout="2000" v-model="snackbarSuccess">Message sent successfully</v-snackbar>
      <v-snackbar color="error" top timeout="2000" v-model="snackbarError">Message not sent, try later</v-snackbar>
    </v-container>
    <v-dialog v-model="HistoryDialog" max-width="290" >
      <v-card>
        <v-card-title class="headline">{{ dialogHistoryData.title.split(' ')[0]}} <br v-if="ViewMobile"> {{ dialogHistoryData.title.split(' ')[1] == null || dialogHistoryData.title.split(' ')[1] == '' ? '' : dialogHistoryData.title.replace(dialogHistoryData.title.split(' ')[0],'').trim()}}</v-card-title>
        <v-card-text class="text-justify">
          {{dialogHistoryData.description}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="HistoryDialog = false" > Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="DialogLanguage" max-width="400" >
      <v-card>
        <v-card-title class="headline">English</v-card-title>
        <v-card-text class="text-justify">
          <v-simple-table>
            <template>
              <thead>
                <tr>
                  <th class="text-center">Listening</th>
                  <th class="text-center">Reading</th>
                  <th class="text-center">Speaking</th>
                  <th class="text-center">Writing</th>
                </tr>
              </thead>
              <tbody>
                <tr class="noHover">
                  <td>B2</td>
                  <td>C1</td>
                  <td>A2</td>
                  <td>B1</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="DialogLanguage = false" > Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <rodape class="mt-16"/> 
  </v-main>
</template>

<script>
// @ is an alias to /src
import heads from '@/components/head.vue'
import rodape from '@/components/rodape.vue'
import { VueTyper } from 'vue-typer'
import { required, email, max } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import emailjs from 'emailjs-com';

setInteractionMode('eager')

extend('required', {
  ...required,
  message: '{_field_} can not be empty',
})

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
})

extend('email', {
  ...email,
  message: 'Email must be valid',
})

export default {
  name: 'Home',
  components: {
    heads,
    rodape,
    VueTyper,
    ValidationProvider,
    ValidationObserver
  },
  data: () => ({
    textName: 'Hi, I’m Fábio Cardoso',
    textShow: ["LET'S WORK TOGETHER", 'I CAN CREATE AWESOME STUFF'],
    textApren: 'Hi there! I’m Fábio Cardoso',
    textDev: 'Developer',
    textAllApren: '   I worked for 1 year as developer in the area RPA, Robotic Process Automation, creating and concluding several projects for several companies' +
     ' and created activities for the others developers to use. Personally, I have a project at hand for the Academic Federation of Viana do Castelo that is a web application in Vuejs.'+
    ' I strive to learn a lot with my seniors, well as teach. I have a great spirit of teamwork, I am willing and I always like to help the others any way I can.',
    scrollPosition: 0,
    ViewMobile: false,
    ViewTablet: false,
    HistoryDialog: false,
    dialogHistoryData: {
      title: 'teste',
      data: '',
      description: ''
    },
    arrHistoryWork: [ { company: 'Ubiquity Technology', data: '06/2018 - 06/2019' ,description: 'Developer RPA (Robotic Process Automation) at Ubiquity Technology where I worked on numerous projects with the UiPath tool, as well as developed activities for other developers to use and improve the robot.'},
                      { company: 'Ubiquity Technology', data: '02/2018 - 06/2018' ,description: 'Curricular internship at Ubiquity Technology with a duration of 600 hours where I played the role of RPA (Robotic Process Automation) developer where I developed the skills of proactivity, teamwork, sense of responsibility and being more ornate.'},
                      { company: 'Informoldes', data: '03/2016 - 06/2016' ,description: 'Curricular internship at the company informoldes, Lda with a duration of 520 hours. The functions performed were 3D modeling in the solidworks software and cnc operator (Computer numerical command).'},
    ],
    arrHistorySchool: [{ company: 'Computer Science', data: '17/09/2018 – Current' ,description: 'Degree in Computer Engineering at the School of Technology and Management of the Polytechnic Institute of Viana do Castelo which I am still finishing.'},
    { company: 'Information Systems Technologies and Programming ', data: '19/09/2016 – 16/07/2018' ,description: 'The Information Systems Technologies and Programming course I took serves to be a professional in application software maintenance oriented to web, distributed and mobile context, as well as architecture, design, planning and control of software development for organizational contexts. The chairs I liked and the most important ones were Algorithm and Programming, Project Management, Database, Architecture and software design and Object Oriented Programming.'},
    { company: 'Industrial maintenance Technician', data: '16/09/2013 – 21/06/2016' ,description: 'Professional Industrial Maintenance Technician Course - Electromechanical that I took in the School Group of Ponte de Lima with interest in 3D modeling, 3D printers and CNC machines.'}],
    arrSkills: [
      {
        skill: 'HTML',
        value: 100
      },
      {
        skill: 'PHP',
        value: 70
      },
      {
        skill: 'RPA UiPath',
        value: 100
      },
      {
        skill: 'NODEJS',
        value: 70
      },
      {
        skill: 'VUEJS',
        value: 90
      },
      {
        skill: 'C',
        value: 100
      },
      {
        skill: 'C#',
        value: 30
      },
      {
        skill: 'JS',
        value: 90
      },
      {
        skill: 'ANGULARJS',
        value: 60
      },
      {
        skill: 'JAVA',
        value: 50
      },
      {
        skill: 'SQL',
        value: 80
      }
    ],
    loadingMail: false,
    mail_parms: {
      from_name: '',
      from_mail: '',
      message: ''
    },
    DialogLanguage: false,
    snackbarSuccess: false,
    snackbarError: false
  }),
  methods: {
    dialogHistory(data) {
      if(this.HistoryDialog) {
        this.HistoryDialog = false;
      } else {
        if(this.ViewMobile){
          this.HistoryDialog = true;
        }
      }
      this.dialogHistoryData.title = data.company;
      this.dialogHistoryData.description = data.description;
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    handleView() {
      this.ViewMobile = window.innerWidth <= 425;
      if(window.innerWidth <= 990){
        if(window.innerWidth > 425){
          this.ViewTablet = true;
        }
      }
    },
    sendEmail() {
      this.loadingMail = true;
      emailjs.send('service_un0q7a5', 'template_9dvbrcn', this.mail_parms, 'user_jtGa8TNrQkdO7YBeeOxek' ).then((result) => {
          this.snackbarSuccess = true;
          this.snackbarError = false;
          this.loadingMail = false;
          console.log('SUCCESS!', result.status, result.text);
        }, (error) => {
          this.snackbarSuccess = false;
          this.snackbarError = true;
          this.loadingMail = false;
          console.log('FAILED...', error);
        });
    }
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
    window.addEventListener('resize', this.handleView);
  },
  computed: {
  },
  created() {
    console.log("created");
    console.log("tablet: " + this.ViewTablet);
    this.handleView();
  }
}
</script>

<style scoped>

.bg_img {
  position: relative;
  height: 100vh;
  min-height: 550px;
  background-image: url(../assets/img/background.png);
  background-repeat: no-repeat;
  background-position: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -ms-background-size: cover;
  background-size: cover;
}

.bg_img::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.60);
  z-index: 0;

}

.upper_layer {
  position: relative;
  z-index: 20;
}

.img_perfil {
  border: 4px solid #FFC000 !important;
}

.text_dev {
  color: #FFC000 !important;
}

ul {
  list-style: none
}

li::before {
  content: "•"; 
  color: #FFC000;
  display: inline-block;
  width: 1em;
  margin-left: -1em
}

li > span {
  color:#7F7F7F;
}

.color_orange {
  background-color: #FFC000 !important;

}

.text-hover:hover {
  text-decoration-line: underline;
  cursor: pointer;
  opacity: 0.8;

}

.noHover{
    pointer-events: none;
}


</style>

<style >

.vue-typer .custom.char.typed {
  color: #ffffff;
}

.vue-typer .custom.caret {
  display: none;
}

</style>
 